import formatter from '../utilities/Formatter';

export default (value, dec = 2) => (!!value || value === 0) ? formatter.formatDollarValue(value, dec) : '';
